import * as React from "react";
import { inject, observer } from "mobx-react";
import { Route } from "react-router-dom";
import IComPage from "@templates/page";
import IComStartpage from "@templates/startpage";
import IComCheckout from "@templates/checkout";
import IComCategory from "@templates/category";
import IComFilter from "@templates/filter";
import IComConfirmation from "@templates/confirmation";
import Login from "@templates/login";
import IComFilterPagePopup from "@templates/filterpagepopup";
import SimplePage from "@templates/simplepage";
//import IComDealers from "@templates/dealers";
//import StoreLocator from "./storelocator";
//import SiteSelector from "./siteselector";
import IComReactComponent from "./reactcomponent";
import Account from "@templates/account";
import IComHistory from "@templates/history"

@observer
export default class TemplateRenderer extends React.Component {
    constructor(props) {
        super(props);

        this.templates = {
            //SiteSelector: SiteSelector,
            IComStartpage: IComStartpage,
            IComCategory: IComCategory,
            IComFilter: IComFilter,
            IComPage: IComPage,
            IComLogin: Login,
            IComAccount: Account,
            IComCheckout: IComCheckout,
            IComConfirmation: IComConfirmation,
            IComHistory: IComHistory,
            IComReactComponent: IComReactComponent,
            IComFilterPagePopup: IComFilterPagePopup,
            SimplePage: SimplePage
        }

        if (this.props.templates) {
            this.templates = { ... this.templates, ...this.props.templates };
        }

        this.state = {
            header: null
        }

        this.setHeader = this.setHeader.bind(this);
    }

    setHeader(jsx) {
        //console.log("header", jsx);
        this.setState({ header: jsx });
    }



    render() {
        const navigation = this.props.navigation;

        if (navigation && navigation.TemplateAlias) {
            const templateAlias = navigation.TemplateAlias;
            const Template = this.templates[templateAlias] || IComPage;

            //return (<div>Lenght:{this.props.store.navigation.pageContent.SiteId}</div>);
            return (
                <React.Fragment>
                    {navigation.Messages && Array.isArray(navigation.Messages) &&
                        <div className="container-fluid">
                            {navigation.Messages.map(m => {
                                return (<div key={m} className="alert alert-warning" role="alert">{m}</div>);
                            })}
                        </div>
                    }
              
                    {/*{this.state.header}*/}

                    <Template
                        headerCallback={this.setHeader}
                        //model={navigation.pageContent}
                        isMobile={navigation.isMobile}
                        navigation={navigation}
                        {...this.props}
                    />
                </React.Fragment>
            );
        }

        return null;
    }
}

class BrowserHelper extends React.Component {
    constructor(props) {
        super(props);



    }

    componentDidMount() {

        this.scrollToTop("componentDidMount");
    }

    componentDidUpdate(prevProps, prevState) {
        console.debug("pageContent update", prevProps, prevState, this.props.store.navigation.pageContent === prevProps.store.navigation.pageContent);
        if (this.props.navigation.pageContent && this.props.navigation.pageContent.Url !== this.previousUrl) {
            this.scrollToTop("componentDidUpdate");
            this.previousUrl = this.props.navigation.pageContent.Url;
        }
    }



    render() {

        const pageContentClasses = [
            "page-content",
            this.props.navigation.TemplateAlias
        ];

        return (
            <div ref={this.myRef}
                className={pageContentClasses.join(" ")}
                // Trick to remove ios-rubberband-scroll on parent  
                onTouchStart={(e) => {
                    var element = this.myRef.current;
                    var top = element.scrollTop, totalScroll = element.scrollHeight, currentScroll = top + element.offsetHeight;
                    if (top === 0) {
                        element.scrollTop = 1;
                    } else if (currentScroll === totalScroll) {
                        element.scrollTop = top - 1;
                    }
                }}
            >
                {this.props.children}
            </div>
        );
    }


}